export default {
      id: "MaskGroup(2)-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#MaskGroup(2)",
      toString: function () {
        return this.url;
      }
    }